import { render, staticRenderFns } from "./ExchangeCurrencyListTable.vue?vue&type=template&id=6cd28183&"
import script from "./ExchangeCurrencyListTable.vue?vue&type=script&lang=js&"
export * from "./ExchangeCurrencyListTable.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeCurrencyListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports